import { TabPanel, a11yProps } from './tabPanel'

export { TabPanel, a11yProps }
